import styled from 'styled-components';

const Cell = styled.td`
  padding: 1em;

  &:first-child {
    padding-left: 30px;
  }

  &:last-child {
    padding-right: 30px;
  }
`;

export const RightAlignedCell = styled(Cell)`
  text-align: right;
`;

export const CenterAlignedCell = styled(Cell)`
  text-align: center;
`;

export default Cell;
